// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__333oK","ranges":"BmiRanges_ranges__3FPAq"};